import React, { useState, useEffect, useRef, useMemo } from 'react';
import { db } from '../firebase';
import { collection, addDoc, getDoc, onSnapshot, serverTimestamp, doc, updateDoc, setDoc } from 'firebase/firestore';
import { useAuth } from '../AuthProvider';
import { useUserPrefs } from '../UserPrefsProvider';
import PageWrapperAuto from '../components/PageWrapperAuto.js';
import { useUI } from '../UIContext';
import Login from '../Login';
import { useNavigate } from 'react-router-dom';
import { useActiveSession } from '../ActiveSessionContext';
import AbcNotation from '../components/AbcNotation';
import AbcImportPreview from '../components/AbcImportPreview';
import KeyInput from '../components/KeyInput'; // adjust path as needed
import { normalizeKey, normalizeType, keyRoot, normalizeTagsArray, normalizeTag } from '../utils/normalize';
import { sanitizeAbcBody } from '../components/sanitizeAbcBody';
import myIcon from '../assets/logo512.png'; // adjust path
import { cleanAndFillAbc } from '../utils/cleanAndFillAbc';

import BorderedBox from '../components/BorderedBox'; // adjust path if needed

import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { storage } from "../firebase"; // make sure this is correct
import CustomTagInput from '../components/CustomTagInput';
import dexie from '../offlineDB';

import { addPendingWrite, flushPendingWrites } from '../utils/flushPendingWrites'; // you already have this





export default function AddTunePage() {

  console.log('=== AddTunePage INIT ===');


const auth = useAuth();
console.log('auth.user:', auth.user);

const sessionDebug = useActiveSession();
console.log('active session:', sessionDebug);



  const { activeSession: session, setActiveSession: setSession } = useActiveSession();
  const { inputStyle, textStyle, cardStyle, abcEditorStyle } = useUI();
  const { user } = useAuth();
  const [attachments, setAttachments] = useState([]);

 

  const userPrefsContext = useUserPrefs();
  const prefs = userPrefsContext?.prefs;
  console.log('prefs:', prefs);

  const navigate = useNavigate();

  const [tunes, setTunes] = useState([]);
  const [keySuggestions, setKeySuggestions] = useState([]);

  const [sessionUrl, setSessionUrl] = useState('');
  const [selectedTune, setSelectedTune] = useState(null);
  const [locationInput, setLocationInput] = useState('');
  const [duplicateTune, setDuplicateTune] = useState(null);
  const [confirmationMessage, setConfirmationMessage] = useState(null);
  const [similarTunes, setSimilarTunes] = useState([]);
  const [suggestedTunes, setSuggestedTunes] = useState([]);
  const [sessionSearchAbort, setSessionSearchAbort] = useState(null);
  const [customAbcOverride, setCustomAbcOverride] = useState('');
  const [newTune, setNewTune] = useState({
  title: '', genre: '', type: '', key: '', status: '', composer: '', rating: '',recordings: [],
 customTags: []
});
const [focused, setFocused] = useState(false);

  const textareaRef = useRef(null);
  const fileInputRef = useRef(null);
  const [importedTune, setImportedTune] = useState(null);
  const [sessionSearchAttempted, setSessionSearchAttempted] = useState(false);
const [currentRoot, canonicalDefaults, rawSuggestions] = useMemo(() => {
  const inputKey = (newTune.key || '').trim();
  const root = keyRoot(inputKey);  // 👈 no toUpperCase yet


  

 

  const canon = [
    `${root} major`,
    `${root} minor`,
    `${root} dorian`,
    `${root} mixolydian`
  ];

  const dynamicSet = new Set(canon);
  if (keySuggestions[root]) {
    keySuggestions[root].forEach(k => dynamicSet.add(k));
  }


  return [root, canon, Array.from(dynamicSet)];
}, [newTune.key, keySuggestions]);


const [tagSuggestions, setTagSuggestions] = useState([]);


  const [importFields, setImportFields] = useState({
    title: true, type: true, key: true, abc: true
  });


  const handleFileUpload = async (e) => {
  const files = Array.from(e.target.files);

  if (!files.length || !user || !user.uid) {
    alert("Upload blocked: user not fully authenticated.");
    return;
  }

  const uploaded = [];

  for (const file of files) {
    console.log("📤 Starting upload:", file.name);
    try {
      const storageRef = ref(storage, `users/${user.uid}/tunes/temp/${file.name}`);
      await uploadBytes(storageRef, file);
      const url = await getDownloadURL(storageRef);

      uploaded.push({
        name: file.name,
        type: file.type,
        url,
        uploadedAt: new Date().toISOString(),
        file
      });
    } catch (err) {
      console.error("❌ Upload failed for", file.name, err);
    }
  }

  setAttachments((prev) => [...prev, ...uploaded]);

  // ✅ Clear the file input box
  if (fileInputRef.current) {
    fileInputRef.current.value = null;
  }
};
useEffect(() => {
  if (!user) return;

  const preload = async () => {
    try {
      if (navigator.onLine) {
        await flushPendingWrites(user); // 🧠 sync offline writes first
      }
    } catch (err) {
      console.warn("Error syncing pending writes:", err);
    }
  };
  preload();

  const tunesRef = collection(db, 'users', user.uid, 'tunes');
  return onSnapshot(tunesRef, snapshot => {
    const fetchedTunes = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    setTunes(fetchedTunes);

    const tagSet = new Set();
    fetchedTunes.forEach(t => {
      (t.customTags || []).forEach(tag => tagSet.add(tag));
    });
    const tagSuggestions = Array.from(tagSet);
    setTagSuggestions(tagSuggestions);

    const normalizedKeys = fetchedTunes.map(t => normalizeKey(t.key));
    const groupedByRoot = {};
    const roots = ['C', 'C#', 'Db', 'D', 'D#', 'Eb', 'E', 'E#', 'Fb', 'F', 'F#', 'Gb', 'G', 'G#', 'Ab', 'A', 'A#', 'Bb', 'B', 'Cb'];
    roots.forEach(root => {
      groupedByRoot[root.toUpperCase()] = new Set([
        `${root} major`,
        `${root} minor`,
        `${root} dorian`,
        `${root} mixolydian`
      ]);
    });
    normalizedKeys.forEach(nk => {
      const root = keyRoot(nk).toUpperCase();
      if (!groupedByRoot[root]) groupedByRoot[root] = new Set();
      groupedByRoot[root].add(`${root} major`);
      groupedByRoot[root].add(`${root} minor`);
      groupedByRoot[root].add(`${root} dorian`);
      groupedByRoot[root].add(`${root} mixolydian`);
      groupedByRoot[root].add(nk);
    });

    setKeySuggestions(groupedByRoot);
  });
}, [user]);




  useEffect(() => {
    if (prefs) {
      setNewTune(prev => ({
        ...prev,
        genre: prefs.defaultGenre || 'Irish',
        type: prefs.defaultType || '',
        key: prefs.defaultKey || '',
status: prefs.defaultStatus === '—' ? '' : prefs.defaultStatus || 'Need to Learn'
      }));
    }
  }, [prefs]);

  useEffect(() => {
  if (textareaRef.current) {
    textareaRef.current.style.height = 'auto'; // Reset height
    textareaRef.current.style.height = textareaRef.current.scrollHeight + 'px'; // Set to scroll height
  }
}, [customAbcOverride]);
const [originalAbc, setOriginalAbc] = useState('');

  useEffect(() => {
    if (importedTune?.versions) {
      const raw = importedTune.versions[importedTune.selectedIndex].abc || '';
      const cleaned = cleanAndFillAbc({
        rawAbc: raw,
        type: normalizeType(importedTune.type),
        key: normalizeKey(importedTune.key)
      });
      setCustomAbcOverride(cleaned);
      setOriginalAbc(cleaned);

    }
  }, [importedTune?.selectedIndex]);



  const handleChange = (e) => {
const updated = { ...newTune, [e.target.name]: e.target.value };
if (e.target.name === 'title' && typeof updated.title !== 'string') {
  console.warn('⚠️ Invalid title value:', updated.title);
}
    setNewTune(updated);

    if ((e.target.name === 'title' || e.target.name === 'type') && prefs?.enableAutoSuggest !== 'no') {
const lower = (updated?.title ?? '').toString().trim().toLowerCase();

setDuplicateTune(
  tunes.find(t =>
    (t?.title ?? '').toString().trim().toLowerCase() === lower &&
    t?.type === updated?.type
  ) || null
);

setSimilarTunes(
  tunes.filter(t =>
    (t?.title ?? '').toString().trim().toLowerCase().includes(lower) &&
    t?.type === updated?.type &&
    (t?.title ?? '').toString().trim().toLowerCase() !== lower
  )
);

      if (sessionSearchAbort) sessionSearchAbort.abort();
      if (lower.length < 3) return setSuggestedTunes([]);

      const controller = new AbortController();
      setSessionSearchAbort(controller);
      fetch(`https://thesession.org/tunes/search?q=${encodeURIComponent(updated.title)}&format=json`, { signal: controller.signal })
        .then(res => res.json())
        .then(data => {
          const matches = Array.isArray(data.tunes) ? data.tunes.filter(t => t.name.toLowerCase().includes(lower)).slice(0, 5) : [];
          setSuggestedTunes(matches);
        })
        .catch(err => {
          if (err.name !== 'AbortError') console.error('Suggestion error:', err);
        });
    }
  };

  const addTune = async () => {
  if (!newTune.title) return;
const normalizedNewTitle = (newTune?.title ?? '').toString().trim().toLowerCase();
const normalizedNewType = (newTune?.type ?? '').toString();

const exists = tunes.find(t => 
  (t?.title ?? '').toString().trim().toLowerCase() === normalizedNewTitle &&
  (t?.type ?? '').toString() === normalizedNewType
);
  if (exists && !window.confirm(`A tune titled "${exists.title}" already exists as a ${exists.type}. Add anyway?`)) return;

  try {
    const sessionData = session ? [{
      sessionId: session.id,
      location: session.location,
      startedAt: session.startedAt || new Date().toISOString()
    }] : [];

    const normalizedTune = {
      ...newTune,
      customTags: normalizeTagsArray(newTune.customTags),
      type: normalizeType(newTune.type),
genre: typeof newTune.genre === 'string'
  ? newTune.genre.charAt(0).toUpperCase() + newTune.genre.slice(1).toLowerCase()
  : '',
      key: normalizeKey(newTune.key),
      abc: '',
      chords: '',
      lyrics: '',
      notes: '',
      link1: '',
      link2: '',
      link3: '',
      source: '',
      sessions: sessionData,
      attachments: []
    };

    const docId = crypto.randomUUID();
    const data = {
      ...normalizedTune,
      createdAt: navigator.onLine ? serverTimestamp() : new Date().toISOString()
    };

    if (navigator.onLine) {
      await setDoc(doc(db, 'users', user.uid, 'tunes', docId), data);
    } else {
await dexie.tunes.put({
  id: docId,
  ...data,
  attachments: attachments.map(file => ({
    name: file.name,
    type: file.type || file.file?.type || 'application/octet-stream',
    uploadedAt: file.uploadedAt || new Date().toISOString(),
    pending: true // 🔁 will need syncing
  }))
});

await addPendingWrite({
  type: 'add',
  collection: 'tunes',
  docId,
  data: {
    ...data,
    attachments: attachments.map(file => ({
      name: file.name,
      type: file.type || file.file?.type || 'application/octet-stream',
      uploadedAt: file.uploadedAt || new Date().toISOString(),
      pending: true
    }))
  }
});

    }

    // Handle attachments only if online (defer otherwise)
    let movedAttachments = [];
    if (attachments.length > 0 && navigator.onLine) {
      for (const file of attachments) {
        const fullPath = `users/${user.uid}/tunes/${docId}/${file.name}`;
        const destRef = ref(storage, fullPath);
        await uploadBytes(destRef, file.file);
        const newUrl = await getDownloadURL(destRef);

        movedAttachments.push({
          name: file.name,
          type: file.type || file.file?.type || 'application/octet-stream',
          url: newUrl,
          path: fullPath,
          uploadedAt: file.uploadedAt || new Date().toISOString()
        });
      }

      await updateDoc(doc(db, 'users', user.uid, 'tunes', docId), {
        attachments: movedAttachments
      });

      await dexie.tunes.put({ id: docId, ...data, attachments: movedAttachments });
    }

    setNewTune({
      title: '',
      genre: prefs?.defaultGenre || 'Irish',
      type: prefs?.defaultType || '',
      key: prefs?.defaultKey || '',
      status: prefs?.defaultStatus || 'Need to Learn',
      composer: '',
      rating: '',
      recordings: [],
      customTags: []
    });

    setAttachments([]);
    setDuplicateTune(null);
    setSimilarTunes([]);
    setConfirmationMessage({
      msg: session ? 'Tune added to open session' : 'Tune added!',
      id: docId
    });
    setTimeout(() => setConfirmationMessage(null), 10000);

try {
  const prefsDocId = 'settings';
  const prefsRef = doc(db, 'users', user.uid, 'preferences', prefsDocId);

  const snap = navigator.onLine ? await getDoc(prefsRef) : null;
  const existing = snap?.exists() && Array.isArray(snap.data().customTags)
    ? snap.data().customTags
    : [];

  const merged = Array.from(new Set([
    ...normalizeTagsArray(newTune.customTags || []),
    ...existing.map(normalizeTag)
  ]));

  if (navigator.onLine) {
    await updateDoc(prefsRef, { customTags: merged });
  } else {
    await dexie.preferences.put({ id: prefsDocId, customTags: merged });
    await addPendingWrite({
      type: 'update',
      collection: 'preferences',
      docId: prefsDocId,
      data: { id: prefsDocId, customTags: merged }
    });
  }
} catch (err) {
  console.warn("Could not sync tags to preferences", err);
}


  } catch (err) {
    console.error(err);
    alert('Error saving tune');
  }
};



const importFromSession = async (tuneId) => {
  try {
    const res = await fetch(`https://thesession.org/tunes/${tuneId}?format=json`);
    const data = await res.json();
    const settings = data.settings || [];

    const versions = settings.map((setting, index) => {
      const abcLines = [
        'X:1',
        `T:${data.name || ''}`,
        `M:${setting.meter || ''}`,
        `L:${setting.unit_note_length || ''}`,
        `R:${data.type || ''}`,
        `Q:${setting.tempo || ''}`,
        `Z:${data.transcribed_by || ''}`,
        `S:${data.source || ''}`,
        `N:${data.note || ''}`,
        `K:${setting.key || ''}`,
        setting.abc || ''
      ];
      return {
        index,
        key: setting.key || '',
        source: setting.source || '',
        transcribed_by: setting.transcribed_by || '',
        abc: abcLines.join('\n'),
      };
    });

    setImportedTune({
      id: tuneId,
      title: data.name || '',
      type: data.type || '',
      key: settings[0]?.key || '',
      versions,
      selectedIndex: 0,
      link: `https://thesession.org/tunes/${tuneId}`
    });

    setImportFields({ title: true, type: true, key: true, abc: true });

  } catch (err) {
    console.error(err);
    alert('Error importing tune');
  }
};


 const saveImportedTune = async () => {
  if (!importedTune) return;

  const fields = {};
  Object.keys(importFields).forEach(f => {
    if (f !== 'abc' && importFields[f]) {
      fields[f] = importedTune[f] || '';
    }
  });

  const rawAbc = customAbcOverride || importedTune.versions?.[importedTune.selectedIndex]?.abc || '';
  fields.abc = cleanAndFillAbc({
    rawAbc,
    type: importedTune.type,
    key: importedTune.key
  });

  try {
    const ref = await addDoc(collection(db, 'users', user.uid, 'tunes'), {
      ...fields,
      type: normalizeType(fields.type),
      genre: 'Irish',
      key: normalizeKey(fields.key),
      status: prefs?.defaultStatus === '—' ? '' : prefs?.defaultStatus || 'Need to Learn',
      customTags: [], // ← ✅ still blank initially
      link1: importedTune.link,
      chords: '', lyrics: '', notes: '', link2: '', link3: '', source: '',
      createdAt: serverTimestamp(),
      sessions: session
        ? [{
            sessionId: session.id,
            location: session.location,
            startedAt: session.startedAt || new Date().toISOString()
          }]
        : []
    });

    if (session) {
      localStorage.setItem('currentSession', JSON.stringify(session));
    }

    // Reset the preview panel and show confirmation message
    setImportedTune(null);
    setImportFields({ title: true, type: true, key: true, abc: true });
    setNewTune(prev => ({ ...prev, title: '' }));
    setSuggestedTunes([]);
    setConfirmationMessage({
      msg: 'Tune saved from TheSession.org',
      id: ref.id
    });
    setTimeout(() => setConfirmationMessage(null), 10000);

    // 🔄 Sync any tags added during import to preferences
    try {
      const prefsRef = doc(db, 'users', user.uid, 'preferences', 'settings');
      const snap = await getDoc(prefsRef);
      const existing = snap.exists() && Array.isArray(snap.data().customTags)
        ? snap.data().customTags
        : [];

      const importedDoc = await getDoc(ref);
      const tuneTags = importedDoc.exists() && Array.isArray(importedDoc.data().customTags)
        ? importedDoc.data().customTags
        : [];

      const merged = Array.from(new Set([...existing, ...tuneTags]));
      await updateDoc(prefsRef, { customTags: merged });
    } catch (err) {
      console.warn("Could not sync tags to preferences during import", err);
    }

  } catch (err) {
    console.error(err);
    alert('Error saving imported tune');
  }
};

const startSession = async () => {
  if (!user) return;

  const location = locationInput.trim() || 'Unnamed';
  const startedAt = new Date().toISOString(); // use ISO format for offline consistency

  const sessionData = {
    location,
    startedAt,
  };

  try {
    let sessionDoc;
    const docId = crypto.randomUUID();

    if (navigator.onLine) {
      sessionDoc = await addDoc(collection(db, 'users', user.uid, 'sessions'), {
        ...sessionData,
        startedAt: serverTimestamp()
      });
    } else {
      await dexie.sessions.put({ id: docId, ...sessionData });
      await addPendingWrite({
        type: 'add',
        collection: 'sessions',
        docId,
        data: { id: docId, ...sessionData }
      });
      sessionDoc = { id: docId };
    }

    setSession({
      id: sessionDoc.id,
      ...sessionData
    });

    localStorage.setItem('currentSession', JSON.stringify({
      id: sessionDoc.id,
      ...sessionData
    }));
  } catch (err) {
    console.error('Error starting session:', err);
    alert('Could not start session');
  }
};


const endSession = async () => {
  if (!user || !session) return;

  if (window.confirm('End the current session?')) {
    try {
      const updatedData = { endedAt: new Date().toISOString() };
      const ref = doc(db, 'users', user.uid, 'sessions', session.id);

      if (navigator.onLine) {
        await updateDoc(ref, { endedAt: serverTimestamp() });
      } else {
        await dexie.sessions.update(session.id, updatedData);
        await addPendingWrite({
          type: 'update',
          collection: 'sessions',
          docId: session.id,
          data: { id: session.id, ...updatedData }
        });
      }

      setSession(null);
      localStorage.removeItem('currentSession');
    } catch (err) {
      console.error('Failed to log session end:', err);
      alert('Could not end session');
    }
  }
};



  const genreOptions = prefs?.customGenres?.length ? prefs.customGenres : ['Irish', 'Old-Time', 'Bluegrass'];
  const typeOptions = prefs?.customTypes?.length ? prefs.customTypes : ['Jig', 'Reel', 'Hornpipe', 'Waltz', 'Polka', 'Song'];
const statusOptions = ['Status (—)', 'Need to Learn', 'Learning', 'Learned'];
  const ratingOptions = ['Rating (—)', '★', '★★', '★★★', '★★★★', '★★★★★'];

  if (!user) return <PageWrapperAuto><Login /></PageWrapperAuto>;

  return (
    <PageWrapperAuto>
     <div className="app-title" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '0.75rem', marginBottom: '0.5rem' }}>
    <img src={myIcon} alt="Logo" className="responsive-icon" />
    <span>Add Tunes</span>
  </div>
        
      <div style={{ height: '10px' }} />

      <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', margin: '0 auto 20px auto', alignItems: 'center' }}>
        
              
       <div style={{ width: '100%', maxWidth: '300px' }}>
<input
  name="title"
  placeholder="Title"
  value={typeof newTune.title === 'string' ? newTune.title : ''}
  onChange={handleChange}
  style={{ ...inputStyle, width: '100%' }}
/>

      </div>


        {suggestedTunes.length > 0 && (
          <div className="text-scaled">
            <span className="text-scaled">Suggestions from thesession.org</span>
            <ul style={{ listStyle: 'none', paddingLeft: 0 }}>
            {suggestedTunes.map((t, i) => (
        <li key={i}>
      <button onClick={() => importFromSession(t.id)}>{t.name} ({t.type})</button>
    </li>
  ))}
</ul>


            {importedTune && (
<div style={{ marginTop: '10px', ...cardStyle }}>
    <h3 className="text-scaled">Review</h3>

      {/* Save and exit button */}
<div
  style={{
    display: 'flex',
    gap: '12px',
    justifyContent: 'center',
    marginTop: '20px',
    marginBottom: '10px',
    flexWrap: 'wrap'
  }}
>
  <button className="big-button" onClick={saveImportedTune}>
    Save Imported Tune
  </button>
  <button
    className="big-button"
    style={{ backgroundColor: '#444', color: '#fff' }}
    onClick={() => {
      setImportedTune(null);
      setImportFields({ title: true, type: true, key: true, abc: true });
      setCustomAbcOverride('');
    }}
  >
    Exit
  </button>
</div>



    {/* Other fields */}
    {Object.keys(importFields)
      .filter(f => f !== 'abc')
      .map((field) => (
        <label
          key={field}
          className="text-scaled"
          style={{ display: 'block', marginBottom: '8px' }}
        >
          <input
            type="checkbox"
            checked={importFields[field]}
            onChange={(e) =>
              setImportFields(prev => ({
                ...prev,
                [field]: e.target.checked
              }))
            }
          />
          <strong> {field.charAt(0).toUpperCase() + field.slice(1)}:</strong>{' '}
<span style={{ color: 'var(--text-muted)' }}>
  {field === 'key'
    ? normalizeKey(importedTune.key || '')
    : field === 'type'
      ? normalizeType(importedTune.type || '')
      : typeof importedTune[field] === 'string'
        ? importedTune[field] || '(none)'
        : '(unavailable)'}
</span>


        </label>
      ))}

  {/* ABC checkbox */}
    <label className="text-scaled" style={{ display: 'block', marginBottom: '8px' }}>
      <input
        type="checkbox"
        checked={importFields.abc}
        onChange={(e) =>
          setImportFields(prev => ({ ...prev, abc: e.target.checked }))
        }
      />
      <strong> ABC:</strong>{' '}
      <span style={{ color: 'var(--text-muted)' }}>
        {customAbcOverride?.trim() ? 'Preview and save' : '(none)'}
      </span>

    </label>
    
    {/* ABC preview (only if checked) */}
<AbcImportPreview
  importedTune={importedTune}
  setImportedTune={setImportedTune}
  importFields={importFields}
  customAbcOverride={customAbcOverride}
  setCustomAbcOverride={setCustomAbcOverride}
  originalAbc={originalAbc}
  setOriginalAbc={setOriginalAbc}
/>

  </div>
)}

</div>
)}
<div style={{ width: '100%', maxWidth: '300px', display: 'flex', justifyContent: 'center', paddingLeft: '14px' }}>
  <div style={{ width: '75%' }}>
          <select
            name="genre"
            value={newTune.genre}
            onChange={handleChange}
            style={{ ...inputStyle, width: '100%' }}
          >
            {genreOptions.map((g, i) => (
              <option key={i} value={g}>{g}</option>
            ))}
          </select>
          </div>
        </div>


  <div style={{ width: '100%', maxWidth: '300px', display: 'flex', justifyContent: 'center', paddingLeft: '14px' }}>
  <div style={{ width: '75%' }}>
          <select 
            name="type" 
            value={newTune.type} 
            onChange={handleChange} 
            style={{ ...inputStyle, width: '100%' }}
          >
            {typeOptions.map((t, i) => 
              <option key={i} value={t}>{t}
              </option>)}
          </select>
          </div>
        </div>
  


<div style={{ width: '100%', maxWidth: '300px', display: 'flex', justifyContent: 'center', paddingLeft: '14px' }}>
  <div style={{ width: '75%' }}>
  <KeyInput
    value={newTune.key}
    onChange={handleChange}
    style={{ ...inputStyle, width: '100%' }}
    suggestions={rawSuggestions}
    inputStyle={{ ...inputStyle }}
    textStyle={textStyle}
  />
</div>
</div>




<div style={{ width: '100%', maxWidth: '300px', display: 'flex', justifyContent: 'center', paddingLeft: '14px' }}>
  <div style={{ width: '75%' }}>
          <select 
           name="status" 
           value={newTune.status} 
           onChange={handleChange} 
           style={{ ...inputStyle, width: '100%' }}>
            {statusOptions.map((s, i) => 
            <option key={i} value={s}>{s}
            </option>)}
          </select>
        </div>
        
    </div>
        
    <div style={{ width: '100%', maxWidth: '300px', display: 'flex', justifyContent: 'center', paddingLeft: '14px' }}>
  <div style={{ width: '75%' }}>
          <select 
          name="rating" 
          value={newTune.rating} 
          onChange={handleChange} 
          style={{ ...inputStyle, width: '100%' }}>
            {ratingOptions.map((r, i) => 
            <option key={i} value={r}>{r}
            </option>)}
          </select>
          </div>
        </div>
     
     {/* Tags field row */}
<div style={{ width: '100%', maxWidth: '300px', margin: '0 auto 6px' }}>
  <CustomTagInput
    tags={newTune.customTags}
    setTags={(tags) => setNewTune(prev => ({ ...prev, customTags: tags }))}
    suggestions={tagSuggestions}
    inputStyle={inputStyle}
  />
</div>


{/* Attachments */}
<div style={{ width: '100%', maxWidth: '300px' }}>
  <input
    ref={fileInputRef}
    type="file"
    accept="image/*,.pdf"
    multiple
    onChange={handleFileUpload}
    style={{ ...inputStyle, width: '100%' }}
  />
</div>



<div style={{ marginTop: '0.5rem', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
  {attachments.map((file, i) => (
    <div
      key={i}
      style={{
        fontSize: '0.85rem',
        color: 'var(--text-secondary)',
        display: 'flex',
        alignItems: 'center',
        gap: '0.5rem',
        marginBottom: '4px',
        maxWidth: '280px',        // constrain to keep layout tight
        justifyContent: 'space-between',
        width: '100%',
      }}
    >
      <span style={{ overflowWrap: 'anywhere', flex: 1 }}>{file.name}</span>
      <button
        onClick={() => {
          setAttachments(prev => prev.filter((_, index) => index !== i));
        }}
        style={{
          background: 'transparent',
          border: 'none',
          fontSize: '1rem',
          color: 'var(--text-secondary)',
          cursor: 'pointer',
          lineHeight: 1,
          flexShrink: 0
        }}
        title="Remove file"
      >
        ×
      </button>
    </div>
  ))}
</div>







        
        <button className="big-button" onClick={addTune}>Add Tune</button>
        
    {confirmationMessage && (
      <div
        className="confirmation-message"
        style={{
          backgroundColor: '#003366',
          color: 'white',
          padding: '0.75rem 1rem',
          marginBottom: '1rem',
          borderRadius: '6px',
          textAlign: 'center',
          cursor: 'pointer'
        }}
        onClick={() => navigate(`/tune/${confirmationMessage.id}/edit`)}
      >
        {confirmationMessage.msg} <span style={{ opacity: 0.8 }}>(Click to edit)</span>
      </div>
    )}


      </div>

<BorderedBox
  style={{
    marginTop: '1rem',
    padding: '1.3rem',
    paddingTop: '0.75rem',
    paddingBottom: '1.25rem',
    maxWidth: '380px',
    marginLeft: 'auto',
    marginRight: 'auto',
    textAlign: 'center'
  }}
>
  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem', marginBottom: '0.5rem' }}>
    <span role="img" aria-label="session" style={{ fontSize: '1.5rem' }}>🎤</span>
    <h3 style={{ margin: 2 }}>Start a Session</h3>
  </div>

  {session ? (
    <>
      <p className="text-scaled" style={{ marginBottom: '1rem' }}>
        <strong>Active Session:</strong><br />
{session.location} — {new Date(session.startedAt).toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' })}
      </p>
<button className="big-button" onClick={endSession}>End Session</button>
    </>
  ) : (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.75rem' }}>
      <input
        placeholder="Location/Name (optional)"
        value={locationInput}
        onChange={e => setLocationInput(e.target.value)}
        style={{
          ...inputStyle,
          fontSize: '1rem',
          padding: '0px 10px',
          lineHeight: '1.2',
          height: '2rem',
          maxWidth: '240px',
          width: '100%'
        }}
      />
      <button className="big-button" onClick={startSession}>Start Session</button>
    </div>
  )}
</BorderedBox>




    </PageWrapperAuto>
  );
}
